import { render, staticRenderFns } from "./OrdreEixidaList.vue?vue&type=template&id=39c94bce&scoped=true"
import script from "./OrdreEixidaList.vue?vue&type=script&lang=js"
export * from "./OrdreEixidaList.vue?vue&type=script&lang=js"
import style0 from "./OrdreEixidaList.vue?vue&type=style&index=0&id=39c94bce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c94bce",
  null
  
)

export default component.exports